<template>
  <div class="customize">
    <div class="customize__in">
      <div class="wrapper">
        <div class="customize-photo">
          <button class="btn btn-back abs" @click.prevent="handleBack('/')">
            <span>{{ trans.text.customize.back }}</span>
          </button>
          <img v-if="hasImage" :alt="getModelTitle" :src="getModelImage">
        </div>

        <div class="customize-info">
          <div class="customize-info-title hidden-xs">
            <h1>{{ trans.text.customize.chooseSize }}</h1>
          </div>

          <div v-show="filteredProducts.length > 0" class="customize-select">
            <div class="customize-select__list">
              <label v-for="product in filteredProducts"
                     class="customize-select-item">
                <input
                  :checked="isProductSelected(product)"
                  name="product"
                  type="radio"
                  @change="selectProduct($event, product)">
                <div class="customize-select-item__in">
                  <div class="customize-select-item__text">
                    <p>
                      <b>{{ getFrameTitle(getFramePart(product)) }}</b>
                    </p>
                    <p>{{ getFrameDescription(getFramePart(product)) }}</p>
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div v-for="category in productCategories" v-if="showCategory(category)" class="customize-select">
            <div class="customize-select__heading">
              <h3>{{ getPartCategoryTitle(category) }}</h3>
            </div>
            <div class="customize-select__list">
              <label v-for="(product, index) in sortParts(category, category.comp_parts)"
                     v-if="showPartSelector(product, category)"
                     class="customize-select-item">
                <input
                  :checked="isChecked(product, category)"
                  :name="getGroupName(category)"
                  type="radio"
                  @change="selectPartInCategory($event, category, product)">
                <div class="customize-select-item__in">
                  <div class="customize-select-item__text">
                    <div>{{ getPartTitle(product) }}</div>
                    <div>{{ getPartDescription(product) }}</div>
                  </div>
                  <div class="customize-select-item__price">{{ getPriceDiff(category, product) }}</div>
                </div>
              </label>
            </div>
          </div>

          <div class="customize__footer">
            <p>{{ trans.text.customize.sizeRecommendations }}</p>
          </div>

          <div class="customize__reservation">
            <div class="customize-info-title">
              <h1>{{ trans.text.customize.paymentOptions }}</h1>
            </div>

            <div :class="{disabled:isReservationDisabled}" class="reservation">
              <div :class="{selected: preorder === true}" class="reservation__option"
                   @click="selectReservation('preorder')">
                <div class="reservation__option-in">
                  <div class="reservation__advantages">
                    <div class="reservation__advantages-headline">
                      <h5>{{ trans.text.customize.reservation }}</h5>
                    </div>

                    <div class="reservation__advantages-items">
                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l">
                          <span>
                              <b>{{ trans.text.customize.amount }}</b>
                          </span>
                          <span>€ 2,000.00</span>
                        </div>
                      </div>

                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l">
                          <span>{{ trans.text.customize.preSalesPrice }}</span>
                          <span>
                              <b>€ 7,999.00</b>
                          </span>
                        </div>
                      </div>

                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l">
                          <span>{{ trans.text.customize.extra }}</span>
                          <span>-</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="reservation__option-footer">
                    <p>{{ trans.text.customize.info1 }}</p>
                    <p>{{ trans.text.customize.info2 }}</p>
                    <br>
                    <p>{{ trans.text.customize.info6 }}</p>
                    <p>{{ trans.text.customize.info7 }}</p>
                  </div>
                </div>
              </div>

              <div :class="{selected: preorder === false}" class="reservation__option"
                   @click="selectReservation('full')">
                <div class="reservation__option-in">
                  <div class="reservation__advantages">
                    <div class="reservation__advantages-headline">
                      <h5>{{ trans.text.customize.purchase }}</h5>
                    </div>

                    <div class="reservation__advantages-items with-border">
                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l">
                          <span><b>{{ trans.text.customize.amount }}</b></span>
                          <span>{{ trans.text.customize.fullPayment }}</span>
                        </div>
                      </div>

                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l">
                          <span>{{ trans.text.customize.excPreSalesPrice }}</span>
                          <span><b v-if="this.currentProduct">{{ selectedPrice }}</b><b v-else>€ 7,499.00</b></span>
                        </div>
                      </div>

                      <div class="reservation__advantages-item">
                        <div class="reservation__advantages-item_l with-extra">
                          <span>{{ trans.text.customize.extra }}</span>
                          <span>
                            <span>{{ trans.text.customize.firstDelivery }}</span>
                            <span>{{ trans.text.customize.frameNumberSelection }}</span>
                            <span>{{ trans.text.customize.supply }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="reservation__numbers">
                    <div class="reservation__numbers-headline">
                      <div class="reservation__numbers-headline_l">
                        <span v-if="!numberAlreadyInUseError">{{ trans.text.customize.yourFrameNumber }}</span>
                        <span v-if="numberAlreadyInUseError" class="error">{{ numberAlreadyInUseError }}</span>
                        <p v-show="showChooseTitle && showSelectHundreedTitle">
                          {{ trans.text.customize.firstDigit }}</p>
                        <p v-show="showChooseTitle && showSelectDecadesTitle">
                          {{ trans.text.customize.secondDigit }}</p>
                        <p v-show="showChooseTitle && showSelectUnitsTitle">
                          {{ trans.text.customize.thirdDigit }}</p>
                        <p v-show="showChooseTitle && showConfirmFrameNumberTitle">
                          {{ trans.text.customize.confirmNumber }}</p>
                        <a v-show="!showChooseTitle" class="link" href="#"
                           @click.prevent="backStep()">{{ trans.text.customize.editAgain }}</a>
                      </div>

                      <div v-if="!numberAlreadyInUseError" class="reservation__numbers-headline_r">
                        <span>
                            <span>{{ hundreedsSelectedValue }}</span>
                            <span>{{ decadesSelectedValue }}</span>
                            <span>{{ unitsSelectedValue }}</span>
                        </span>
                      </div>
                    </div>

                    <div class="reservation__numbers-items">
                      <div class="reservation__numbers-items_in">
                        <div
                          v-for="item in hundreeds"
                          v-if="showHundreedSelector"
                          :class="{active: hundreedsSelectedValue === item.value, disabled: (preorder === true || preorder === null)}"
                          class="reservation__numbers-item"
                          @click.prevent="selectHundreeds(item)">
                          <div class="reservation__numbers-item_in">
                            <span>{{ item.title }}</span>
                          </div>
                        </div>

                        <div
                          v-for="item in decades"
                          v-if="showDecadesSelector"
                          :class="{active: decadesSelectedValue === item.value, disabled: (preorder === true || preorder === null)}"
                          class="reservation__numbers-item"
                          @click.prevent="selectDecades(item)">
                          <div class="reservation__numbers-item_in">
                            <span>{{ item.title }}</span>
                          </div>
                        </div>

                        <div
                          v-for="item in units"
                          v-if="showUnitsSelector"
                          :class="{active: unitsSelectedValue === item.value, disabled: (preorder === true || preorder === null||isReservedFrame(item))}"
                          class="reservation__numbers-item"
                          @click.prevent="selectUnits(item)"
                        >
                          <div
                            :class="{'reservation__numbers-item_in':!isReservedFrame(item),'is-reservation__numbers-item_in':isReservedFrame(item)}"
                          >
                            <span>{{ item.title }}</span>
                          </div>
                        </div>

                      </div>

                      <div class="reservation__numbers-footer">
                        <button
                          v-show="hundreedsSelected" class="btn btn-back"
                          @click="backStep()"
                        >
                          <span>{{ trans.text.customize.stepBack }}</span>
                        </button>

                        <button
                          v-show="showChooseTitle"
                          :class="{disabled: !unitsSelected}"
                          :disabled="!unitsSelected"
                          class="btn btn-done"
                          @click="selectDone()"
                        >
                          <span>{{ trans.text.customize.confirm }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="reservation__option-footer mobNone">
                    <p>
                      <strong>{{ trans.text.customize.warnAboutReservation }}</strong>
                    </p>
                    <p>{{ trans.text.customize.info3 }}</p>
                    <p>{{ trans.text.customize.info4 }}</p>
                    <p>{{ trans.text.customize.info5 }}</p>
                    <br>
                    <p>{{ trans.text.customize.info6 }}</p>
                    <p>{{ trans.text.customize.info7 }}</p>
                  </div>
                </div>
              </div>
            </div>
            <p class="customize-period"> {{ trans.text.customize.info8 }}</p>
            <div class="reservation__option-footer desNone">
              <p>
                <strong>{{ trans.text.customize.warnAboutReservation }}</strong>
              </p>
              <p>{{ trans.text.customize.info3 }}</p>
              <p>{{ trans.text.customize.info4 }}</p>
              <p>{{ trans.text.customize.info5 }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="customize-geometry" style="text-align: center">
      <div class="wrapper">
        <div class="flex">
          <div class="customize-info-title desNone"><h1 class="h1">{{ trans.text.customize.geometryTable }}</h1>
          </div>
          <div class="geometry-wrap">
            <img
              ref="image-map"
              alt="Geometry"
              src="/assets/images/geometry.png"
              style="max-width: 100%;"
              usemap="#geometry-map">
            <map name="geometry-map">
              <area coords="624,48,660,48,662,14,625,15" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'a')">
              <area coords="698,72,733,72,734,105,699,106" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'b')">
              <area coords="700,381,733,380,735,417,699,416" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'c')">
              <area coords="334,500,368,489,381,522,349,535" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'd')">
              <area coords="295,741,334,742,333,775,295,774" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'e')">
              <area coords="1061,585,1096,588,1094,619,1057,617" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'f')">
              <area coords="453,178,491,179,490,212,454,212" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'g')">
              <area coords="35,710,74,710,72,746,35,746" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'h')">
              <area coords="664,818,659,778,697,781,701,817" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'i')">
              <area coords="970,114,1003,96,1023,130,989,149" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'j')">
              <area coords="701,722,734,722,735,757,699,757" shape="poly"
                    target="_self"
                    @mouseover="switchTable($event, 'k')">
            </map>
          </div>
          <div class="geoTable-wrap">
            <div class="customize-info-title mobNone"><h1 class="h1">
              {{ trans.text.customize.geometryTable }}</h1></div>
            <table class="geoTable">
              <thead>
              <tr>
                <th></th>
                <th></th>
                <th>S</th>
                <th>M</th>
                <th>L</th>
                <th>XL</th>
              </tr>
              </thead>
              <tbody>
              <tr :class="{active: isLetterActive('a')}">
                <td>A</td>
                <td>{{ trans.text.customize.topTubeHorizontal }}</td>
                <td><span class="size">579</span><span class="mm">mm</span></td>
                <td><span class="size">609</span><span class="mm">mm</span></td>
                <td><span class="size">648</span><span class="mm">mm</span></td>
                <td><span class="size">673</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('b')}">
                <td>B</td>
                <td>{{ trans.text.customize.reach }}</td>
                <td><span class="size">428</span><span class="mm">mm</span></td>
                <td><span class="size">458</span><span class="mm">mm</span></td>
                <td><span class="size">488</span><span class="mm">mm</span></td>
                <td><span class="size">508</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('c')}">
                <td>C</td>
                <td>{{ trans.text.customize.stack }}</td>
                <td><span class="size">612</span><span class="mm">mm</span></td>
                <td><span class="size">612</span><span class="mm">mm</span></td>
                <td><span class="size">625</span><span class="mm">mm</span></td>
                <td><span class="size">639</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('d')}">
                <td>D</td>
                <td>{{ trans.text.customize.seattubeLength }}</td>
                <td><span class="size">420</span><span class="mm">mm</span></td>
                <td><span class="size">430</span><span class="mm">mm</span></td>
                <td><span class="size">465</span><span class="mm">mm</span></td>
                <td><span class="size">500</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('e')}">
                <td>E</td>
                <td>{{ trans.text.customize.chainstayHorizontal }}</td>
                <td><span class="size">436</span><span class="mm">mm</span></td>
                <td><span class="size">436</span><span class="mm">mm</span></td>
                <td><span class="size">446</span><span class="mm">mm</span></td>
                <td><span class="size">446</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('f')}">
                <td>F</td>
                <td>{{ trans.text.customize.headtubeAngle }}</td>
                <td><span class="size">64</span><sub class="mm">°</sub></td>
                <td><span class="size">64</span><sub class="mm">°</sub></td>
                <td><span class="size">64</span><sub class="mm">°</sub></td>
                <td><span class="size">64</span><sub class="mm">°</sub></td>
              </tr>
              <tr :class="{active: isLetterActive('g')}">
                <td>G</td>
                <td>{{ trans.text.customize.seattubeAngle }}</td>
                <td><span class="size">77</span><sub class="mm">°</sub></td>
                <td><span class="size">77</span><sub class="mm">°</sub></td>
                <td><span class="size">77</span><sub class="mm">°</sub></td>
                <td><span class="size">77</span><sub class="mm">°</sub></td>
              </tr>
              <tr :class="{active: isLetterActive('h')}">
                <td>H</td>
                <td>{{ trans.text.customize.bbDrop }}</td>
                <td><span class="size">-25</span><span class="mm">mm</span></td>
                <td><span class="size">-25</span><span class="mm">mm</span></td>
                <td><span class="size">-25</span><span class="mm">mm</span></td>
                <td><span class="size">-25</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('i')}">
                <td>I</td>
                <td>{{ trans.text.customize.wheelbase }}</td>
                <td><span class="size">1208</span><span class="mm">mm</span></td>
                <td><span class="size">1238</span><span class="mm">mm</span></td>
                <td><span class="size">1284</span><span class="mm">mm</span></td>
                <td><span class="size">1311</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('j')}">
                <td>J</td>
                <td>{{ trans.text.customize.headtubeLength }}</td>
                <td><span class="size">95</span><span class="mm">mm</span></td>
                <td><span class="size">95</span><span class="mm">mm</span></td>
                <td><span class="size">110</span><span class="mm">mm</span></td>
                <td><span class="size">125</span><span class="mm">mm</span></td>
              </tr>
              <tr :class="{active: isLetterActive('k')}">
                <td>K</td>
                <td>{{ trans.text.customize.bbHeight }}</td>
                <td><span class="size">353</span><span class="mm">mm</span></td>
                <td><span class="size">353</span><span class="mm">mm</span></td>
                <td><span class="size">353</span><span class="mm">mm</span></td>
                <td><span class="size">353</span><span class="mm">mm</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="requiredCategories.length > 0" class="customize-spec">
      <div class="wrapper">

        <div class="customize-info-title">
          <h1>{{ trans.text.customize.specifications }}</h1>
        </div>

        <div class="customInfo">
          <div v-for="category in requiredCategories" class="item">
            <h3>{{ category.title }}</h3>
            <p>
              {{ category.description }}
              <span>{{ category.fullDescription }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="customize-foot">
      <div class="wrapper">
        <div v-if="preorder === true || preorder === false" class="customize-foot__total">
          <span v-if="preorder === false">{{ selectedPrice }}</span>
          <span v-if="preorder === true">{{ $crConverter(2000, "EUR") }}</span>
        </div>
        <div v-if="isEmailNotVerified" class="customize-foot__email-info">
          <p>{{ trans.text.customize.mustConfirm }}</p>
          <span
            :ref="'resendLinkText'"
            :class="{error: resendLinkError}"
            @click.prevent="resendLink()"
          >
            {{ trans.text.customize.resendLink }}
          </span>
        </div>
        <div class="customize-foot__button">
          <button
            :class="bagButtonClasses"
            :disabled="isAddToBagButtonDisabled"
            class="btn"
            @click="toBag()"
          >
            {{ addToBagText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ImageMap from "image-map";

export default {
  props: ['slug', 'product', 'lang', 'trans'],
  name: "CustomizeProductComponent",
  data() {
    return {
      resendLinkError: false,
      currentProduct: null,
      selectedProduct: null,
      currentSet: false,
      title: 'Forestal',
      selectedParts: {},
      sortedCategories: [],
      products: [],
      loadingText: 'Add to bag',
      firstSearch: true,
      preorder: null,
      currentLetter: null,
      numberSelected: false,
      hundreedsSelected: false,
      hundreedsSelectedValue: '-',
      hundreeds: [
        {
          value: 0,
          title: '0 - -'
        },
        {
          value: 1,
          title: '1 - -'
        },
        {
          value: 2,
          title: '2 - -'
        },
        {
          value: 3,
          title: '3 - -'
        },
        {
          value: 4,
          title: '4 - -'
        },
        {
          value: 5,
          title: '5 - -'
        },
        {
          value: 6,
          title: '6 - -'
        },
        {
          value: 7,
          title: '7 - -'
        },
        {
          value: 8,
          title: '8 - -'
        },
        {
          value: 9,
          title: '9 - -'
        },
      ],
      decadesSelected: false,
      decadesSelectedValue: '-',
      unitsSelected: false,
      unitsSelectedValue: '-',

      numberAlreadyInUseError: null
    }
  },
  mounted() {
    ImageMap('img[usemap]')
    this.loadingText = this.trans.text.customize.addToBag

    document.getElementsByTagName('body')[0].classList.add('fix-padding')
  },
  computed: {
    showSelectHundreedTitle() {
      return !this.hundreedsSelected;
    },
    showSelectDecadesTitle() {
      return this.hundreedsSelected && !this.decadesSelected;
    },
    showSelectUnitsTitle() {
      return this.hundreedsSelected && this.decadesSelected && !this.unitsSelected;
    },
    showConfirmFrameNumberTitle() {
      return this.hundreedsSelected && this.decadesSelected && this.unitsSelected;
    },
    isReservationDisabled() {
      return !this.selectedProduct
    },
    bagButtonClasses() {

      return {
        'btn-gray': this.isAddToBagButtonDisabled,
        'btn-green': !this.isAddToBagButtonDisabled,
        'disabled': this.isAddToBagButtonDisabled //сдклай чтоб при классе disabled курсор не менялся и цвет кнопки
      }
    },
    decades() {
      let prefix = `${this.hundreedsSelectedValue}`;
      return [
        {
          value: 0,
          title: `${prefix} 0 -`
        },
        {
          value: 1,
          title: `${prefix} 1 -`
        },
        {
          value: 2,
          title: `${prefix} 2 -`
        },
        {
          value: 3,
          title: `${prefix} 3 -`
        },
        {
          value: 4,
          title: `${prefix} 4 -`
        },
        {
          value: 5,
          title: `${prefix} 5 -`
        },
        {
          value: 6,
          title: `${prefix} 6 -`
        },
        {
          value: 7,
          title: `${prefix} 7 -`
        },
        {
          value: 8,
          title: `${prefix} 8 -`
        },
        {
          value: 9,
          title: `${prefix} 9 -`
        },
      ]
    },
    units() {
      let prefix = `${this.hundreedsSelectedValue} ${this.decadesSelectedValue}`;
      let units = [
        {
          value: 1,
          title: `${prefix} 1`
        },
        {
          value: 2,
          title: `${prefix} 2`
        },
        {
          value: 3,
          title: `${prefix} 3`
        },
        {
          value: 4,
          title: `${prefix} 4`
        },
        {
          value: 5,
          title: `${prefix} 5`
        },
        {
          value: 6,
          title: `${prefix} 6`
        },
        {
          value: 7,
          title: `${prefix} 7`
        },
        {
          value: 8,
          title: `${prefix} 8`
        },
        {
          value: 9,
          title: `${prefix} 9`
        },
      ];

      if (this.decadesSelectedValue !== 0) {
        units.unshift({
          value: 0,
          title: `${prefix} 0`
        });
      }

      return units;
    },
    showHundreedSelector() {
      return !this.hundreedsSelected;
    },
    showDecadesSelector() {
      return this.hundreedsSelected && !this.decadesSelected;
    },
    showUnitsSelector() {
      return this.hundreedsSelected && this.decadesSelected && (!this.unitsSelected || !this.numberSelected);
    },
    showChooseTitle() {
      return !this.numberSelected;
    },
    showEditBtn() {
      return this.hundreedsSelected && this.decadesSelected && this.unitsSelected;
    },
    ...mapGetters(['getCurrentModel', 'stockModel', 'getRelCategories', 'getProducts', 'allModelProducts', 'storage', 'getAuthUser']),
    language() {
      return this.lang;
    },
    filteredProducts() {
      if (this.products.length > 0) {
        let productsWithFrameIDs = [];
        let products = [];

        for (let product of this.products) {
          if (product.store_visibility === 0) {
            break;
          }
          let filteredCategories = product.rel_categories.filter(cat => {
            return cat.en_title.toLowerCase().indexOf('frame') !== -1;
          });

          let part = filteredCategories[0].selected_part[0];

          if (productsWithFrameIDs.indexOf(parseInt(part.id)) === -1) {
            product.frame_part_id = parseInt(part.id);
            products.push({
              data: product,
              price: part.price_out
            });
            productsWithFrameIDs.push(parseInt(part.id));
          }
        }

        products = products.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));

        let tempProducts = [];

        for (let prod of products) {
          tempProducts.push(prod.data);
        }

        return tempProducts;
      }
      return [];
    },
    hasImage() {
      return !!this.getCurrentModel && !!this.getCurrentModel.img;
    },
    getModelTitle() {
      let language = this.lang;
      let prefix = language + '_';
      if (language === 'en') {
        prefix = '';
      }
      if (!!this.getCurrentModel) {
        if (this.getCurrentModel[`${prefix}model`]) {
          return this.getCurrentModel[`${prefix}model`]
        }
        return this.getCurrentModel.model;
      }
      return '';
    },
    getModelImage() {
      return this.getStorageLink(this.getCurrentModel.img);
    },
    productCategories() {
      if (!!this.products && this.products.length > 0 && this.getRelCategories.length > 0) {
        return this.getRelCategories.filter(category => {
          return category.as_option === 1
            && category.en_title.toLowerCase().indexOf('frame') === -1;
        });
      } else {
        return [];
      }
    },
    requiredCategories() {
      if (Array.isArray(this.products) && this.products.length > 0) {
        let selected = this.products[0];
        return selected.model.rel_cats_quantity.map(item => {
          return {
            title: this.getPartCategoryTitle(item),
            description: this.getPartDescription(item.selected_part[0]),
            fullDescription: this.getPartFullDescription(item.selected_part[0]),
            sortOrder: item.pivot.sort_order
          }
        }).sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : -1);
      } else {
        return [];
      }
    },
    selectedPrice() {
      if (Array.isArray(this.currentProduct)) {
        let totalPrice = 0;
        let selectedProduct;

        for (let product of this.currentProduct) {
          let thisProduct = true;
          for (let key of Object.keys(this.selectedParts)) {
            let selectedCategory = product.rel_categories.filter(cat => {
              return parseInt(cat.id) === parseInt(key);
            });

            if (selectedCategory.length === 0) {
              thisProduct = false;
              break;
            }

            let selectedPart = parseInt(this.selectedParts[key].id);
            let currentPartInCategory = parseInt(selectedCategory[0].selected_part[0].id);

            if (selectedPart !== currentPartInCategory) {
              thisProduct = false;
              break;
            }
          }

          if (thisProduct) {
            selectedProduct = product;
            break;
          }
        }

        totalPrice += parseInt(selectedProduct.price);

        for (let category of selectedProduct.rel_categories) {
          if (category.selected_part.length > 0 && category.as_option === 1) {
            totalPrice += parseInt(category.selected_part[0].price_out);
          }
        }
        return this.$crConverter(totalPrice, "EUR");
      }

      if (!!this.currentProduct) {
        let totalPrice = 0;
        totalPrice += parseInt(this.currentProduct.price);

        for (let category of this.currentProduct.rel_categories) {
          if (category.selected_part.length > 0 && category.as_option === 1) {
            totalPrice += parseInt(category.selected_part[0].price_out);
          }
        }

        return this.$crConverter(totalPrice, "EUR");
      }
      return this.$crConverter(0, "EUR");
    },
    addToBagText() {
      return this.loadingText;
    },
    isEmailNotVerified() {
      return !!this.getAuthUser && !(!!this.getAuthUser.email_verified_at) && !(!!this.getAuthUser.create_by);
    },
    isAddToBagButtonDisabled() {
      return !(!!this.currentProduct)
        || this.preorder === null
        || this.isEmailNotVerified;
    },
    addToBagButtonStyle() {
      if (!!this.currentProduct && this.preorder !== null) {
        return null;
      } else {
        return {
          backgroundColor: '#959691'
        };
      }
    }
  },
  watch: {
    slug: {
      handler: function () {
        this.loadCategories();
      },
      deep: true,
      immediate: true
    },
    getCurrentModel: {
      handler: function (model) {
        if (!!model && model.model) {

          this.getModelProducts({
            path: this.$path,
            id: model.id
          });

        }
      }, deep: true, immediate: true
    },
    stockModel: {
      handler: function (val) {
        this.products = val['rel_prods'];
        // this.selectMinimalPriceProduct();
      }
    }
  },
  methods: {
    ...mapActions(['getModel', 'getStockModel', 'AddToBag', 'getModelProducts', 'ResendVerificationLink']),
    resendLink() {
      this.ResendVerificationLink({
        path: this.$path
      }).then(result => {
        let message;
        this.resendLinkError = result === 429 || result === 500;
        if (result === 429) {
          message = 'To many attempts'
        }
        if (result === 500) {
          message = 'Server error, try later'
        }
        if (result === 200) {
          message = this.trans.text.customize.linkSent
        }
        let oldText = this.$refs.resendLinkText.innerText;

        this.$refs.resendLinkText.innerText = message
        setTimeout(() => {
          this.$refs.resendLinkText.innerText = oldText
          this.resendLinkError = false;
        }, 5000)
      });
    },
    switchTable(event, letter) {
      this.currentLetter = letter;
    },
    isLetterActive(letter) {
      return this.currentLetter === letter;
    },
    handleBack(fallback) {
      history.back()
    },
    isReservedFrame: function (item) {
      let text = this.hundreedsSelectedValue.toString() + this.decadesSelectedValue + item.value.toString();
      return this.stockModel.reserved.includes(text) || this.stockModel.auto_reserved.includes(text)
    },
    selectReservation(type) {
      if (this.isReservationDisabled) {
        return;
      }
      this.preorder = type === 'preorder';
    },
    backStep() {
      if (this.unitsSelected) {
        this.unitsSelected = false;
        this.unitsSelectedValue = '-';
        this.numberSelected = false;
      } else {
        if (this.decadesSelected) {
          this.decadesSelectedValue = '-';
          this.decadesSelected = false;
        } else {
          if (this.hundreedsSelected) {
            this.hundreedsSelectedValue = '-';
            this.hundreedsSelected = false;
          }
        }
      }
    },
    selectHundreeds(item) {
      this.hundreedsSelectedValue = item.value;
      this.hundreedsSelected = true;
    },
    selectDecades(item) {
      this.decadesSelectedValue = item.value;
      this.decadesSelected = true;
    },
    selectUnits(item) {
      if (!this.isReservedFrame(item)) {
        this.unitsSelectedValue = item.value;
        this.unitsSelected = true;
      }
    },
    selectDone() {
      this.numberSelected = true;
    },
    getFrameTitle(part) {
      if (!!part) {
        if (part[`block_name_${this.language}`]) {
          return part[`block_name_${this.language}`];
        }
        return part[`block_name_en`];
      }
      return '';
    },
    getFrameDescription(part) {
      if (!!part) {
        if (part[`block_description_${this.language}`]) {
          return part[`block_description_${this.language}`];
        }
        return part[`block_description_en`];
      }
      return '';
    },
    getPartTitle(part) {
      if (!!part) {
        if (part[`title_site_${this.language}`]) {
          return part[`title_site_${this.language}`];
        }
        return part[`title_site_en`];
      }
      return '';
    },
    getPartDescription(part) {
      if (!!part) {
        if (part[`description_short_${this.language}`]) {
          return part[`description_short_${this.language}`];
        }
        return part[`description_short_en`];
      }
      return '';
    },
    getPartFullDescription(part) {
      if (!!part) {
        if (part[`description_full_${this.language}`]) {
          return part[`description_full_${this.language}`];
        }
        return part[`description_full_en`];
      }
      return '';
    },
    getPartCategoryTitle(category) {
      if (!!category) {
        if (category[`${this.language}_title`]) {
          return category[`${this.language}_title`];
        }
        return category[`en_title`];
      }
      return '';
    },
    getFramePriceDiff(product) {
      if (!!this.selectedProduct) {

        if (Array.isArray(this.currentProduct)) {
          let selectedInCurrent = this.currentProduct.filter(prod => {
            return parseInt(prod.id) === parseInt(product.id);
          });

          if (selectedInCurrent.length > 0) {
            return '';
          }
        }

        let selectedPrice = this.getTotalPriceForProduct(this.selectedProduct);
        let otherPrice = this.getTotalPriceForProduct(product);

        let diff = otherPrice - selectedPrice;

        if (diff === 0) {
          return '';
        }

        return (diff > 0 ? '+' : '') + this.$crConverter(diff, 'EUR');
      }
      return '';
    },
    getTotalPriceForProduct(product, selected = false) {
      if (selected) {
        if (Array.isArray(this.currentProduct)) {
          let existInCurrent = this.currentProduct.filter(prod => {
            return parseInt(prod.id) === parseInt(product.id);
          }).length;

          if (existInCurrent > 0) {
            return null;
          }
        }
      }
      let price = parseInt(product.price);
      let filteredCategories = product.rel_categories.filter(category => {
        return category.as_option === 1;
      });

      for (let category of filteredCategories) {
        price += parseInt(category.selected_part[0].price_out);
      }
      return price;
    },
    isProductSelected(product) {
      if (!!this.currentProduct) {
        if (Array.isArray(this.currentProduct)) {
          return this.currentProduct.filter(prod => {
            return parseInt(product.id) === parseInt(prod.id);
          }).length > 0;
        } else {
          return parseInt(product.id) === parseInt(this.currentProduct.id);
        }
      }
      return false;
    },
    selectProduct(event, product) {

      let products = [];

      let currentFrameId = product.frame_part_id;

      for (let prod of this.products) {
        let filteredCategories = prod.rel_categories.filter(cat => {
          return cat.en_title.toLowerCase().indexOf('frame') !== -1;
        });

        let part = filteredCategories[0].selected_part[0];

        if (parseInt(part.id) === currentFrameId) {
          products.push(prod);
        }
      }

      if (products.length > 1) {
        this.$set(this.$data, 'currentProduct', products);
        this.$set(this.$data, 'selectedProduct', this.setMinimalPriceProduct(products));
      } else if (products.length === 1) {
        this.$set(this.$data, 'currentProduct', products[0]);
        this.$set(this.$data, 'selectedProduct', products[0]);
      } else {
        this.$set(this.$data, 'currentProduct', null);
        this.$set(this.$data, 'selectedProduct', null);
      }
      this.selectParts();
    },
    setMinimalPriceProduct(products) {
      let minimalPrice = 0;
      let minimalPriceProduct = null;

      for (let product of products) {
        let currentPrice = parseInt(product.price);

        let filteredCategories = product.rel_categories.filter(category => {
          return category.as_option === 1;
        });

        for (let category of filteredCategories) {
          currentPrice += parseInt(category.selected_part[0].price_out);
        }

        if (currentPrice < minimalPrice || minimalPrice === 0) {
          minimalPrice = currentPrice;
          minimalPriceProduct = product;
        }
      }

      return minimalPriceProduct;
    },
    getFramePart(product, cat = null) {
      let filteredCategories = product.rel_categories.filter(category => {
        return category.as_option === 1 && category.en_title.toLowerCase().indexOf(cat ? cat.en_title : 'frame') !== -1;
      });

      if (filteredCategories.length > 0) {
        return filteredCategories[0].selected_part[0];
      }

      return null;

    },
    loadCategories() {
      this.getModel({
        path: this.$path,
        slug: this.slug
      }).then(response => this.loadStockProducts(response.data.slug));
    },
    loadStockProducts(slug) {
      this.getStockModel({
        path: this.$path,
        slug: slug
      })
    },
    getStorageLink(path) {
      return this.storage + path;
    },
    isSelected(category, part) {
      return this.selectedParts[parseInt(category.id)] === part;
    },
    toBag() {
      let ctx = this;
      this.AddToBag({
        path: this.$path,
        product_id: this.selectedProduct.id,
        quantity: 1,
        lang: this.language,
        frame_number: this.getFrameNumber(),
        is_pre_order: this.preorder === true,
        pre_order_price: this.preorder === true ? parseFloat(2000) : null
      }).then((response) => {
        if (response.gtag) {
          this.$gtag.event('add_to_cart', {
            currency: 'EUR',
            items: [response.gtag]
          })
          setTimeout(() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: response.gtag.name,
                currency: 'EUR',
                value: 50,
                contents: [
                  {
                    id: response.gtag.variant,
                    quantity: response.gtag.quantity,
                  }
                ],
                content_type: 'product'
              })
            }
          })
        }
      }).catch(error => {
        if (error.hasOwnProperty('exist')) {
          ctx.numberAlreadyInUseError = error.message;
        } else {
          ctx.numberAlreadyInUseError = 'Server error, try later';
        }
        setTimeout(function () {
          ctx.numberAlreadyInUseError = null;
        }, 5000)
      });
    },
    getFrameNumber() {
      if (this.preorder === true) {
        return null
      }
      if (this.hundreedsSelected && this.decadesSelected && this.unitsSelected) {
        return `${this.hundreedsSelectedValue}${this.decadesSelectedValue}${this.unitsSelectedValue}`;
      }
      return null;
    },
    sortParts(category, parts) {

      if (!this.sortedCategories.includes(category.id)) {
        parts.sort((a, b) => (parseInt(a.price_out) > parseInt(b.price_out)) ? 1 : ((parseInt(b.price_out) > parseInt(a.price_out)) ? -1 : 0));
        this.sortedCategories.push(category.id);
      }

      return parts;
    },
    getGroupName(category) {
      return `category-${category.id}`;
    },
    getPriceDiff(category, part) {
      let selectedPartPrice = parseInt(this.selectedParts[parseInt(category.id)].price_out);
      let currentPartPrice = part.price_out;

      let diff = currentPartPrice - selectedPartPrice;

      if (diff === 0) {
        return '';
      }

      return (diff > 0 ? '+' : '') + this.$crConverter(diff, 'EUR');
    },
    selectPartInCategory(event, category, part) {
      let checked = event.target.checked;

      if (checked) {
        if (Array.isArray(this.currentProduct)) {
          for (let product of this.currentProduct) {
            let filteredCategories = product.rel_categories.filter(cat => {
              return parseInt(cat.id) === parseInt(category.id);
            });

            if (filteredCategories.length === 0) {
              break;
            }

            if (parseInt(filteredCategories[0].selected_part[0].id) === parseInt(part.id)) {
              this.$set(this.$data, 'selectedProduct', product);
              break;
            }
          }
        }
        this.$set(this.selectedParts, parseInt(category.id), part);
      }
    },
    showCategory(category, notAsOption = false) {
      let compPartsRule = !!category.comp_parts;
      let catAsOptionRule = category.as_option === 1;
      let productRule = this.products.length > 0;
      return compPartsRule && catAsOptionRule && productRule
    },
    selectMinimalPriceProduct() {

      let bySlug = false;

      if (this.product !== 'customize') {
        let filteredProducts = this.products.filter(prod => {
          return prod.hasOwnProperty('detail_info')
            && prod.detail_info.url_name === this.product;

        });

        if (filteredProducts.length === 1) {
          this.$set(this.$data, 'currentProduct', this.setArraySelectedProducts(filteredProducts[0]));
          this.$set(this.$data, 'selectedProduct', filteredProducts[0]);
          bySlug = true;
        }

      }

      if (!bySlug) {
        let minimalPriceObject = null;
        let minimalPrice = 0;
        for (let product of this.products) {
          let currentPrice = product.price;


          for (let category of product.rel_categories) {
            if (category.selected_part.length > 0) {
              currentPrice += parseInt(category.selected_part[0].price_out);
            }
          }


          if (currentPrice < minimalPrice || minimalPrice === 0) {
            minimalPriceObject = product;
            minimalPrice = currentPrice;
          }

        }

        this.$set(this.$data, 'currentProduct', this.setArraySelectedProducts(minimalPriceObject));
        this.$set(this.$data, 'selectedProduct', minimalPriceObject);
      }

      this.selectParts();
    },
    selectParts() {
      let filteredCategories = this.selectedProduct.rel_categories.filter(category => {
        return category.en_title.toLowerCase().indexOf('frame') === -1;
      });

      for (let category of filteredCategories) {
        this.$set(this.selectedParts, parseInt(category.id), category.selected_part[0]);
      }
    },
    setArraySelectedProducts(product) {
      let products = [];

      products.push(product);

      let currentProductFilteredCategories = product.rel_categories.filter(category => {
        return category.en_title.toLowerCase().indexOf('frame') !== -1;
      });

      let currentProductFramePart = currentProductFilteredCategories[0].selected_part[0];

      let otherProducts = this.products.filter(prod => {
        return parseInt(prod.id) !== product.id;
      });

      for (let prod of otherProducts) {
        let otherProductFilteredCategories = prod.rel_categories.filter(category => {
          return category.en_title.toLowerCase().indexOf('frame') !== -1;
        });

        let otherProductFramePart = otherProductFilteredCategories[0].selected_part[0];

        if (parseInt(currentProductFramePart.id) === parseInt(otherProductFramePart.id)) {
          products.push(prod);
        }
      }

      return products;
    },
    showPartSelector(product, cat) {

      if (this.products.length > 0 && !!this.currentProduct) {

        let exist = false;

        if (Array.isArray(this.currentProduct)) {
          for (let prod of this.currentProduct) {
            let filteredCategories = prod.rel_categories.filter(category => {
              return parseInt(category.id) === parseInt(cat.id);
            });

            exist = filteredCategories.length > 0 && parseInt(filteredCategories[0].selected_part[0].id) === parseInt(product.id);
            if (exist) {
              return true;
            }
          }
        } else {
          let filteredCategories = this.currentProduct.rel_categories.filter(category => {
            return parseInt(category.id) === parseInt(cat.id);
          });

          return filteredCategories.length > 0 && parseInt(filteredCategories[0].selected_part[0].id) === parseInt(product.id);
        }

      }
      return false;
    },
    isChecked(product, cat) {
      if (this.products.length > 0 && !!this.selectedProduct) {
        let filteredCategories = this.selectedProduct.rel_categories.filter(category => {
          return parseInt(category.id) === parseInt(cat.id);
        });

        return filteredCategories.length > 0 && parseInt(filteredCategories[0].selected_part[0].id) === parseInt(product.id);
      }
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
.btn.abs {
  position: absolute;
  z-index: 2;
  padding: 10px 30px;
  top: 0;
  left: -8px;
}

.customize-photo {
  .btn.abs {
    top: -53px;
    left: -28px;
  }
}


.customInfo {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 50%;
    max-width: 475px;
    box-sizing: border-box;
    margin-bottom: 2rem;

    &:nth-child(even) {
      margin-left: auto;
    }

    h3 {
      margin: 0;
      font-size: 17px;
      line-height: 22px;
    }

    p {
      font-size: 17px;
      line-height: 22px;
      margin: 0;

      span {
        display: block;
        color: rgba(0, 0, 0, 0.3);
      }
    }

    @media (max-width: 767px) {
      h3, p {
        font-size: 12px;
        line-height: 14px;
      }
      h3 {
        margin-bottom: 6px;
      }
      span {
        margin-top: 6px;
      }
    }
  }
}

.customize__reservation .reservation.disabled {
  .reservation__option:hover:first-child,
  .reservation__option.selected:first-child {
    border-color: #E3E3E3 !important;
    background: #fff !important;
  }
}

.customize__reservation .reservation.disabled .reservation__option:hover,
.customize__reservation .reservation.disabled .reservation__option.selected {
  border-color: #E3E3E3 !important;
  background: #fff !important;
}

.customize-spec table {
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
}

.customize-geometry {
  margin-bottom: 240px;

  .flex {
    display: flex;
    flex-wrap: wrap;
  }

  .geometry-wrap {
    width: 50%;
    //padding-right: 0;
    box-sizing: border-box;
    max-width: 620px;
    padding-right: 2.5rem;
    margin-top: 70px;
  }

  .geoTable-wrap {
    width: 50%;
    text-align: left;
    max-width: 562px;
    margin-left: auto;

    .geoTable {
      width: 100%;

    }
  }

  .geoTable {
    border-collapse: collapse;
    display: block;

    thead, tbody {
      display: block;
      width: 100%;
    }

    tbody {
      tr {
        border-top: 1px solid #e6e6e6;
      }

      tr.active {
        z-index: 1;
        border-color: #C2E900;
        position: relative;

        &:before {
          background: #C2E900;
          content: '';
          width: calc(100% + 20px);
          left: -10px;
          height: calc(100% + 2px);
          z-index: -1;
          top: -1px;
          position: absolute;
        }
      }
    }

    tr {
      width: 100%;
      display: flex;
    }

    th {
      display: block;
      font-weight: bold;
      font-size: 14px;
      line-height: 14px;
      padding: 14px 0;
    }

    td {
      display: block;
      padding: 14px 0;
      font-size: 14px;
      line-height: 14px;

    }

    td, th {
      padding-right: 10px;

      &:last-child {
        padding-right: 0;
      }

      &:nth-child(1) {
        width: 4%;
      }

      &:nth-child(2) {
        width: 56%;
      }

      &:nth-child(3) {
        width: 16%;
      }

      &:nth-child(4) {
        width: 16%;
      }

      &:nth-child(5) {
        width: 16%;
      }

      &:nth-child(6) {
        width: 16%;
      }
    }

    sub.mm {
      vertical-align: top;
    }

    .mm {
      font-size: 12px;
    }

  }
}

.customize__in {
  margin: 0 0 150px;
}

.customize-select-item {

  .customize-select-item__in {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    min-height: 90px;
    border: 1px solid #E3E3E3;
    padding: 20px 20px 20px 40px;
    border-radius: 16px;
    box-sizing: border-box;
    transition: all .2s ease;
    &:before {
      display: none;
    }
    p {
      margin: 0;
      font-size: 12px;

      b {
        font-size: 17px;
        font-weight: 500;
      }
    }
  }

  input:checked {
    & + .customize-select-item__in {
      background-color: #f6f6f6;
      border: 1px solid #C2E900;
      box-sizing: border-box;
      border-radius: 16px;
    }
  }
}

.customize__footer {
  max-width: 292px;

  p {
    font-size: 11px;
    line-height: 150%;
    color: rgba(0, 0, 0, .3);
    margin: 0;
  }
}

.customize-select__list {
  margin: 0 0 1.5rem;
}

.customize__reservation {
  margin: 155px 0 0;

  .reservation__option {

    display: block;
    border: 1px solid #E3E3E3;
    border-radius: 16px 16px 0 0;
    overflow: hidden;
    padding: 2rem 36px 2rem;
    cursor: pointer;

    &:hover,
    &.selected {
      border-color: #C2E900;
      position: relative;
      z-index: 1;
      background: #F6F6F6;

      &:first-child {
        border-bottom: 1px solid #C2E900;
      }
    }

    .reservation__option-in {

      .reservation__advantages {
        .reservation__advantages-headline {
          h5 {
            font-weight: 200;
            font-size: 24px;
            line-height: 18px;
            color: #232323;
            margin: 0 0 20px 0;
            font-weight: 500;
          }
        }

        .reservation__advantages-items {
          &.with-border {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            padding-bottom: 36px;
            margin-bottom: 36px;
          }
        }
      }
    }

    &:first-child {
      border-bottom: 1px solid #E3E3E3;
      margin-bottom: -1px;
    }

    &:nth-child(2) {
      border-radius: 0 0 16px 16px;
    }

    .reservation__advantages-item_l {
      display: flex;
      justify-content: space-between;

      span {
        font-size: 17px;
        line-height: 26px;
        color: #232323;

        b {
          font-weight: 500;
        }

        &:first-of-type {
          /*margin-left: 0;*/
          /*margin-right: auto;*/
        }

        &:last-of-type {
          margin-left: auto;
          margin-right: 0;

        }
      }

      &.with-extra {
        span {
          &:last-of-type {
            display: flex;
            flex-direction: column;

            span {
              display: block;
              text-align: right;
            }
          }
        }
      }
    }

    .reservation__option-footer {
      font-size: 11px;
      line-height: 16px;
      color: #232323;
      opacity: 0.4;
    }
  }

  .reservation__numbers {
    display: flex;
    flex-wrap: wrap;
  }

  .reservation__numbers-headline_r {
    margin-left: auto;
    white-space: nowrap;
  }

  .reservation__numbers-headline_r span {
    font-weight: bold;
    font-size: 20px;
    line-height: 18px;
  }

  .reservation__numbers-headline_l span {
    font-weight: 500;
    font-size: 20px;
    line-height: 18px;
    margin-bottom: 1.5rem;
    display: block;
  }

  .reservation__numbers-headline_l p {
    font-weight: normal;
    font-size: 17px;
    line-height: 26px;
    margin: 0;
  }

  .reservation__numbers-headline {
    width: 100%;
    display: flex;
    margin-bottom: 1rem;
  }

  .reservation__numbers-items {
    width: 100%;
  }

  .reservation__numbers-items_in {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin: -.75rem 0 1rem;
  }

  .reservation__numbers-item_in {
    font-size: 12px;
    color: #232323;

  }

  .is-reservation__numbers-item_in {
    font-size: 12px;
    color: #737373;
  }

  .reservation__numbers-item {
    background: #FFFFFF;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 5px;
    display: block;
    padding: 22px 0;
    width: 60px;
    text-align: center;
    margin-right: calc((100% - (60px * 5)) / 4);
    margin-top: .75rem;
    margin-bottom: .75rem;
  }

  .reservation__numbers-item:hover,
  .reservation__numbers-item:hover.active {
    border: 1px solid #C2E900;
  }

  .reservation__numbers-item:nth-child(5n + 5) {
    margin-right: 0;
  }

  .reservation__numbers-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: calc(100% + 60px);
    margin-left: -30px;
  }

  .reservation__numbers-footer .btn.btn-done {
    margin-left: auto;
  }

  .reservation__numbers-footer .btn {
    font-size: 14px;
    padding: 17px 30px;
    color: #000;
  }

  .reservation__numbers-footer .btn.disabled {
    opacity: 0.3;
    cursor: default;
  }

  .reservation__numbers-footer .btn.disabled:hover {
    cursor: default;
  }

  .reservation__numbers {
    margin-bottom: 2.5rem;
  }

  .reservation__numbers .error {
    color: #E41B1B;
  }

  .reservation__numbers-item.disabled {
    opacity: 0.4;
  }

}

.desNone {
  display: none;
}

@media (max-width: 1280px) {
  .customize__in {
    margin: 0 0 120px;
  }
  .customize-geometry {
    margin-bottom: 150px;

    .geoTable-wrap {
      max-width: 500px;
      width: 500px;
    }

    .geometry-wrap {
      width: calc(100% - 540px);
    }
  }
  .customInfo {
    .item {
      width: 50%;
      max-width: 445px;
      box-sizing: border-box;
      margin-bottom: 2rem;
    }
  }


}

@media (max-width: 1199px) {
  .customize__reservation .reservation__option .reservation__advantages-item_l span {
    font-size: 14px;
  }
}

@media (max-width: 991px) {
  .customize__reservation .reservation__numbers-item_in {
    font-size: 10px;
  }
  .customize__reservation .reservation__numbers-item {
    padding: 19px 0;
    width: 52px;
    margin-right: calc((100% - (52px * 5)) / 4);
  }
  .customize__reservation .reservation__numbers-items_in {
    width: calc(100% + 20px);
    margin-left: -10px;
  }

  .customize__reservation {
    margin: 5rem 0 0;
  }
  .customize-info-title h1 {
    font-size: 20px;
  }
  .customize__reservation .reservation__option .reservation__option-in .reservation__advantages .reservation__advantages-headline h5 {
    font-size: 17px;
    margin: 0 0 10px 0;
  }
  .customize__reservation .reservation__option .reservation__advantages-item_l span {
    font-size: 12px;
  }
  .customize__reservation .reservation__numbers-items_in {
    margin-bottom: 0;
  }
  .customize__reservation .reservation__numbers {
    margin-bottom: 1rem;
  }
}

@media (max-width: 980px) {
  .customize-geometry {
    .geoTable-wrap {
      width: 100%;
      max-width: 500px;
      margin: 0 auto 0;
    }

    .geometry-wrap {
      width: 100%;
      max-width: 500px;
      margin: 0 auto 2rem;
      padding-right: 0;
    }
  }
  .customInfo .item {
    padding-right: 1rem;
  }
}

@media (max-width: 767px) {
  .customInfo .item {
    width: 100%;
    padding-right: 0;

    &:nth-child(even) {
      margin-left: 0;
    }

  }
  .btn.abs {
    display: none;
  }
  .desNone {
    display: block;
  }
  .mobNone {
    display: none;
  }
  .customize-geometry .geoTable td {
    padding: 10px 0;
    font-size: 10px;
    line-height: 10px;
  }

  .reservation__option-footer.desNone {
    margin-top: 40px;
  }
  .customize-geometry {
    margin-bottom: 64px;
  }
  .customize-geometry .geometry-wrap {
    margin: 0 auto 1.5rem;
  }
  .customize__reservation .reservation__numbers {
    margin-bottom: -.5rem;
  }
  .customize-geometry {
    .geoTable {
      td, th {
        padding-right: 5px;

        &:last-child {
          padding-right: 0;
        }

        &:nth-child(1) {
          width: 4%;
        }

        &:nth-child(2) {
          width: 50%;
        }

        &:nth-child(3) {
          width: 13%;
          text-align: right;
        }

        &:nth-child(4) {
          width: 13%;
          text-align: right;
        }

        &:nth-child(5) {
          width: 13%;
          text-align: right;
        }

        &:nth-child(6) {
          width: 13%;
          text-align: right;
        }
      }

      .mm {
        display: none;
      }
    }
  }
  .customize__reservation .reservation__numbers-items_in {
    width: 100%;
    margin-left: 0;
  }
  .customize__reservation .reservation__option {
    display: block;
    border: 1px solid #E3E3E3;
    border-radius: 16px 16px 0 0;
    overflow: hidden;
    padding: 1.5rem 12px 1rem;
    cursor: pointer;
  }
  .customize__reservation .reservation__numbers-headline_l span {
    font-size: 17px;
    margin-bottom: 10px;
  }
  .customize__in {
    margin: 0 0 55px;
  }
  .customize__reservation .reservation__numbers-headline_r span {
    font-size: 17px;
  }
  .customize__reservation .reservation__numbers-headline_l p {
    font-size: 14px;
  }
  .customize-select-item .customize-select-item__in {
    padding: 20px 1.5rem 20px 1.5rem;
  }
  .customize__reservation .reservation__option .reservation__option-in .reservation__advantages .reservation__advantages-items.with-border {
    padding-bottom: 1rem;
    margin-bottom: 2rem;
  }
}

@media (max-width: 330px) {
  .customize__reservation .reservation__numbers-items_in {
    width: calc(100% + 8px);
    margin-left: -4px;
  }

}

</style>
